import { Message } from "../Validation/Message";

export const EmailMessages = {
    VLD_EMAIL_INVALID_SIZE: new Message("VLD_EMAIL_INVALID_SIZE", "Message is too big to send to email queue. Max size is 64kb. Message not queued to send."),
    VLD_EMAIL_NO_TO_ADDRESS: new Message("VLD_EMAIL_NO_TO_ADDRESS", "Email message has no 'to' email address. Message not queued to send."),
    VLD_EMAIL_TO_ADDRESS_NOT_FOUND: new Message<[emailTo: string]>("VLD_EMAIL_TO_ADDRESS_NOT_FOUND", "'To' email address not found for user with id '{0}'. Message not queued to send."),
    VLD_INVALID_EMAIL: new Message("VLD_INVALID_EMAIL", "Send email encountered errors. Some emails could not be sent.")
};
